import { useCallback } from "react";
import { api } from "../lib/api";
import type { ChecklistCommand } from "../lib/api-client/contracts";
import { WorkChecklist } from "./WorkChecklist";

const roles = { buyer: "Client", provider: "Provider" };
export function ContractChecklist({ contractId, status, onAccessLost }: { contractId: string; status: string; onAccessLost?: () => void }) {
  const load = useCallback(() => api.contractWork(contractId), [contractId]);
  const save = useCallback((command: ChecklistCommand) => api.checklistCommand(contractId, command), [contractId]);
  return <WorkChecklist loadWork={load} saveCommand={save} writable={status === "funded"} refreshKey={status}
    minimumLabel={2} maximumLabel={200} roleLabels={roles} onAccessLost={onAccessLost} />;
}
